import React from 'react';

import PasswordResetContainer from './PasswordResetContainer';
import PasswordResetPage from './PasswordResetPage';

const PasswordReset: React.FC = () => (
    <PasswordResetContainer.Provider>
        <PasswordResetPage />
    </PasswordResetContainer.Provider>
);

export default PasswordReset;
